/* eslint-disable no-param-reassign */
// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Container } from './LogsDashboard.style';
import { VehicleLogs, PitLogs } from './components';

type StateType = {
  time: number,
  logType: string,
  title: string,
  showToast: boolean,
  lotNumber: Number,
  entity: string,
};
export type StatePropsType = {
  logs: Array<*>,
  alertLogs: any,
};
export type DispatchPropsType = {
  fetchAllLogsRequest: Function,
};
declare type Props = StatePropsType & DispatchPropsType;

class Logs extends Component<Props & DispatchPropsType, StateType> {
  interval: IntervalID;

  constructor(props) {
    super(props);
    const {
      match: {
        params: { id, type, pitId },
      },
    } = this.props;
    this.state = {
      time: Date.now(),
      showToast: false,
      title: '',
      logType: '',
      lotNumber: pitId,
      entity: type,
    };
    if (type === 'vehicle') {
      this.state.lotNumber = 0;
      switch (id) {
        case '1':
          this.state.title = 'Vehicles inside the mine';
          this.state.logType = 'entry';
          break;
        case '2':
          this.state.title = 'Vehicles entered today';
          this.state.logType = 'entered-today';
          break;
        case '3':
          this.state.title = 'Vehicles exited today';
          this.state.logType = 'exit';
          break;
        case '4':
          this.state.title = 'Material Dispatched today';
          this.state.logType = 'dispatched-today';
          break;
        default:
          this.state.title = 'Price of the material dispatched today';
          this.state.logType = 'price-dispatched-today';
      }
    }
    if (type === 'pit') {
      switch (id) {
        case '1':
          this.state.title = 'Vehicle inside the Pit';
          this.state.logType = 'inside';
          break;
        case '2':
          this.state.title = 'Vehicles heading towards this Pit';
          this.state.logType = 'headed';
          break;
        case '3':
          this.state.title = 'Material dispatched from this Pit (in MT)';
          this.state.logType = 'dispatched-today';
          break;
        default:
          this.state.title = 'Material Dispatched yesterday from this pit (in MT)';
          this.state.logType = 'dispatched-yesterday';
      }
    }
  }

  componentDidMount() {
    this.fetchData();
    this.interval = setInterval(() => this.setState({}, this.fetchData), 20000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchData = () => {
    const { time, logType, lotNumber } = this.state;
    if ((Date.now() - time) / (5 * 60 * 1000) > 1) {
      window.location.reload(false);
    }
    const { fetchAllLogsRequest } = this.props;
    this.setState({ showToast: true });

    fetchAllLogsRequest(logType, lotNumber);
  };

  showToast = (logs) => {
    const alertOptions = {
      position: 'bottom-right',
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
    };
    // eslint-disable-next-line array-callback-return
    logs.disrupt.map((log) => {
      toast.warn(`${log.machine.name} is disrupted`, alertOptions);
    });
    // eslint-disable-next-line array-callback-return
    logs.outage.map((log) => {
      toast.error(`${log.machine.name} is not reachable`, alertOptions);
    });
    this.setState({ showToast: false });
  };

  render() {
    const { logs, alertLogs } = this.props;
    const { showToast, title, logType, entity } = this.state;
    return (
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid md={12} paddingLeft={1} paddingTop={1}>
              <Typography variant="h5" color="text.primary" gutterBottom>
                {title}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1}>
            <Grid md={12} item spacing={1}>
              <Grid spacing={1} md={12}>
                {entity === 'pit' ? <PitLogs data={logs} logType={logType} /> : <VehicleLogs data={logs} logType={logType} />}
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {alertLogs && showToast && this.showToast(alertLogs)}
      </Container>
    );
  }
}

export default withRouter(Logs);
